import { render } from "./final_gradding.vue?vue&type=template&id=6b8c84af"
import script from "./final_gradding.vue?vue&type=script&lang=js"
export * from "./final_gradding.vue?vue&type=script&lang=js"

import "./final_gradding.vue?vue&type=style&index=0&id=6b8c84af&lang=css"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__